import React, { Component } from "react";
import { connect } from "react-redux";

import CarouselComponent from "./CarouselComponent";

import { setBlocDisposition } from "Actions";

class Carousel extends Component {
  render() {
    return <CarouselComponent {...this.props} />;
  }
}
// Connected Component
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  setBlocDisposition: (order, disposition) =>
    dispatch(setBlocDisposition(order, disposition))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Carousel);



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Bloc/Carousel/index.js